import React, { useEffect, useState } from 'react'
import { useGetCertificationQuery } from '../store/certification/CertificationSlice';
import AddEditCertificate from '../components/Certifications/AddEditCertificate';
import { useParams } from 'react-router-dom';

const CertificatesFormpage = ({isEdit}) => {
    const { id } = useParams(); 
    const selectedId= Number(id)
    
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const {
        isLoading,
        data: CertificateReturn,
        refetch: refetchEmployee,
      } = useGetCertificationQuery({
        certificate_id: isEdit ? id : null,
      });

      useEffect(() => {
        if (isEdit && !isLoading && CertificateReturn) {
          const editData = CertificateReturn.data.find((item) => item.id === selectedId);
          setSelectedCertificate(editData);
        } else {
          setSelectedCertificate(null);
        }
      }, [isEdit,isLoading, CertificateReturn]);
    
  return (
    <div>
     <AddEditCertificate
     selectedCertificate={selectedCertificate}
     isEditCertificate={isEdit}
     />
    </div>
  )
}

export default CertificatesFormpage
